import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../../agrari-styles/menu.css'

function InventarioMenu({url}) {
    let [activeItem, cambiarActiveItem] = useState("Actividades")

    return (
        <div className="topnav" >
            <Link 
                className={`${activeItem === "actividades"?"active":null}`} 
                onClick={()=>cambiarActiveItem('actividades')}
                to={`${url}`}>
                Actividades
            </Link>
            <Link 
                className={`${activeItem === "datos"?"active":null}`} 
                onClick={()=>cambiarActiveItem('datos')}
                to={`${url}/datos`}>
                Perfil
            </Link>
            <Link 
                className={`${activeItem === "herramientas"?"active":null}`} 
                onClick={()=>cambiarActiveItem('herramientas')}
                to={`${url}/herramientas`}>
                Herramientas
            </Link>
                <Link 
                className={`${activeItem === "pisca"?"active":null}`} 
                onClick={()=>cambiarActiveItem('pisca')}
                to={`${url}/pisca`}>
                Pisca
            </Link>
            <Link 
                className={`${activeItem === "asistencia"?"active":null}`} 
                onClick={()=>cambiarActiveItem('asistencia')}
                to={`${url}/asistencia`}>
                Asistencia
            </Link>
            <Link 
                className={`${activeItem === "documentos"?"active":null}`} 
                onClick={()=>cambiarActiveItem('documentos')}
                to={`${url}/documentos`}>
                Documentos
            </Link>
        </div>
    )
}

export default InventarioMenu;